import { client } from 'app/api/_client';
import { Endpoints } from 'app/api/helpers';
import { FieldName } from 'app/models/fields/names';
import { getSlug } from 'app/util/headers';
import { FormName } from '@lenderful/domain';

export interface ChecklistRequest {
  formName   : FormName;
  formValues: {
    [key in FieldName]?: any;
  },
  slug: string;
}

/**
 * This maps form values from our forms into the object needed to make the `POST` for
 * our document checklist.
 * 
 * @param formValues 
 * @param {FormName} formName 
 * @returns {ChecklistRequest}
 */
export const mapChecklistRequest = (formValues, formName: FormName): ChecklistRequest => ({
  formName,
  formValues,
  slug: getSlug(),
});

export const postChecklist = (body: ChecklistRequest) => {
  return client
    .post(Endpoints.CHECKLIST, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
